import { connect, } from 'react-redux';
import { AppState, } from '../../sew-core/types/index';
import ConsumerReview from '../components/ConsumerReview';
import { onConsumerReviewsReadMoreClick, } from '../../sew-core/actions';

const mapStateToProps = (state: AppState,) => ({
  consumerReviewAndRating: state.consumerReviewAndRating,
  vehicle: state.vehicle,
});

const mapDispatchToProps = (dispatch,) => ({
  onConsumerReviewsReadMoreClick: () => dispatch(onConsumerReviewsReadMoreClick(),),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ConsumerReview,);
